import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { requestDictionary } from '../common/requestUtil';

import { RootState } from './rootReducer';
import { GET_FARM_ENTITIES_SERVICE_URL } from '../api/lelyBackend/config';
import { Nullable } from '../common/types';

type EntityType = {
  isAvailable: boolean;
  name: string;
  type: string;
  stateColor: string;
  id: string;
  kpis: [];
  uri: string;
};

type EntityStateType = {
  name: string;
  stateColor: string;
  type?: string;
};

type FarmDetailsType = {
  farmEntities: Nullable<EntityType[]>;
  farmId: string;
  farmName: string;
  farmTimeZone: string;
  requestUuid?: number;
};

type FarmDetailsStateType = {
  entitiesState: Nullable<EntityStateType[]>;
  farmDetails: Nullable<FarmDetailsType>;
  isFarmDetailsError: boolean;
  errorMessage: string;
  currentSelectedEntityDetails: any;
};

export const farmDetailsInitialState: FarmDetailsStateType = {
  entitiesState: null,
  farmDetails: null,
  isFarmDetailsError: false,
  errorMessage: '',
  currentSelectedEntityDetails: null,
};

export const farmDetails = createSlice({
  name: 'farmDetails',
  initialState: farmDetailsInitialState,
  reducers: {
    getFarmEntitiesStateSuccess: (
      state,
      action: PayloadAction<
        {
          name: string;
          stateColor: string;
        }[]
      >,
    ) => {
      state.entitiesState = action.payload;
    },
    setCurrentSelectedEntity: (state, action) => {
      state.currentSelectedEntityDetails = action.payload;
    },
    getFarmDetailsSuccess: (state, action: PayloadAction<FarmDetailsType>) => {
      if (
        action.payload.requestUuid &&
        requestDictionary[GET_FARM_ENTITIES_SERVICE_URL]
      ) {
        if (
          action.payload.requestUuid !==
          requestDictionary[GET_FARM_ENTITIES_SERVICE_URL]
        ) {
          // ignore this request; it's not the last one of this type that was made
          return; // this effectively ignoring the request/returning the same state as before
        }
      }
      state.farmDetails = action.payload;
      state.isFarmDetailsError = false;
      state.errorMessage = '';
    },
    resetFarmDetails: (state) => {
      state.farmDetails = null;
    },
    getFarmDetailsError: (state, action) => {
      state.errorMessage = action.payload;
      state.farmDetails = null;
      state.isFarmDetailsError = true;
    },
  },
});

export const getFarmEntitiesState = createAction<{
  farmId: string;
}>('GET_FARM_ENTITIES_REQUEST');

export const getFarmDetails = createAction<{
  accessToken: string;
  farmId: string;
  farmName: string;
}>('GET_FARM_DETAILS_REQUEST');

export const {
  getFarmEntitiesStateSuccess,
  setCurrentSelectedEntity,
  getFarmDetailsSuccess,
  resetFarmDetails,
  getFarmDetailsError,
} = farmDetails.actions;

export const farmsDetailsSelectors = {
  entitiesState: (state: RootState) => state.farmDetails.entitiesState,
};

export default farmDetails.reducer;
